import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronRight } from 'react-feather';
import * as S from '../styles';

export const SummarySection = ({ title, items, mode }) => {
  const navigate = useNavigate();
  return (
    <>
      <S.SectionTitle>{title}</S.SectionTitle>
      <S.SummaryList>
        {items.map(item => (
          <S.SummaryItem
            key={item.detail}
            data-testid={`summary-item-${item.label?.toLowerCase().replace(/\s+/g, '-')}`}
            onClick={() => navigate(
              item.link || `/${mode}/accounts`,
              { state: { selectedAccountId: item.id } }
            )}
          >
            <S.ActionIconWrapper>{item.icon}</S.ActionIconWrapper>
            <S.ItemInfo>
              <S.ItemName>{item.label}</S.ItemName>
              <S.ItemDetail>{item.detail}</S.ItemDetail>
            </S.ItemInfo>
            <S.ItemBalance>{item.balance}</S.ItemBalance>
            <ChevronRight size={20} color="#9ca3af" />
          </S.SummaryItem>
        ))}
      </S.SummaryList>
    </>
  );
};
